import {getUpdateGame} from '../api/getUpdateGame';
import { getUpdateLiveGame } from '../api/getUpdateLiveGame';

const setGetUpdateGame = () => {
    return async (dispatch, getState) => {
        try {
            await getUpdateGame();  
            await getUpdateLiveGame();        
        } catch(error) {
            if (error && error.response && error.response.status === 401) {
                localStorage.removeItem('token');
                window.location.replace(window.location.origin);
            }
        }
    }
}

export {
    setGetUpdateGame
}